<template>
<div class="about_menu_top  textalign_left">    
    <div style="background: #fff;max-width: 1920px;margin: 0 auto;"   class="ms-controller fangyicontain">
        <div style="margin: 0 auto;">
            <div style="height: 7300px;background: url('https://p1.fishqc.net/Fk17-1U2VGUFMyMaKECYvdhdSBjU') center center no-repeat;background-size: auto 100%;padding-top: 890px;box-sizing: border-box;">
                <div style="text-align: center;" v-for="(item,index) in productdata">
                    <div class="newyear_text" >{{item.tap}}</div>
                    <div :class="['newyear_desc1',index==1?'lineHeight_46':'',index==2?'lineHeight_2':'']" v-html="item.destext"></div>
                    <div>
                        <div :class="['newyear_box1',index==1?'newyear_box1_padding':'',index==2?'newyear_box2_padding':'']" v-for="itemlist  in item.list">
                        <div :class="['title_position',itemlist.leftposition]">
                            <img :src="itemlist.titleimg" alt="">
                        </div>
                        <div class="newyear_box2">
                            
                            <div class="width872">{{itemlist.desc}}</div>
                        </div>

                        <div>
                            <div class="productdetailcontain" v-for="(val,index) in itemlist.product" @click="toproductdetail(val.type,val.id)">
                                <div class="flex-container" style="height: 100%">
                                    <div class="imgcontain">
                                        <img :src="val.img" :class="[val.class,'center']">
                                        <img src="https://try.fishqc.com/img/addGreenFish.png"  style="width:65px;" class="greenfish"></img>
                                    </div>
                                    <div class="flex-one" style="text-align: left;position: relative;">
                                        <div class="position_center">
                                            <div class="brandcover">
                                                <div class="band" v-html="val.brand"></div>
                                                
                                            </div>
                                            <div class="title" v-html="val.title"></div>
                                            <div class="flex-container justify-content_flex-justify align-items_flex-end" style="padding-right: 24px;box-sizing: border-box;">
                                                <div class="address"  :style="{lineHeight: val.id=='McQ6CJX3p0Cn48EpoJHC6Q'?'40px':'18px'}">品牌所在地：{{val.address}}</div>
                                                <div class="detail-tips"  v-html="val.tips"></div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                    
                </div>

                <img src="https://p1.fishqc.net/Fmc1mnHXhmMpCh-0koWfsqQeykF5" style="display: block;margin:0 auto">

                <div>
                    <img src="https://p1.fishqc.net/FoKKuNu-4IDZN5wyr0BkAttV5-7T" alt="" style="display: block;margin:0 auto">
                </div>
                
            </div>
        </div>
    </div>
</div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";

.newyear_desc1{
    width: 980px;
/*    height: 25px;*/
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 24px;
    margin:0 auto;
    padding-top:24px;
    box-sizing: border-box;
    &.lineHeight_46{
        line-height: 46px;
        width: 950px;
        padding-top:13px;
    }

    &.lineHeight_2{
        padding-top:20px;
    }
    
}

.newyear_text{
    font-size: 42px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #FEFEFE;
    line-height: 42px;
}
.newyear_box1{
    width: 1065px;
    height: 490px;
    background: url('https://p1.fishqc.net/FlJ36zevFdkt9zKXOiv2MEITS_hB') center center no-repeat;
    background-size: contain;
    margin:-26px auto 0;
    padding-top:130px;
    box-sizing: border-box;
    position: relative;
    .title_position{
        position: absolute;
        left:50%;
        top:40px;
        &.leftposition1{
            left:510px;
        }
        &.leftposition2{
            left:510px;
        }
        &.leftposition3{
            left:510px;
        }
        &.leftposition4{
            left:492px;
        }
        &.leftposition5{
            left:476px;
        }
        &.leftposition6{
            left:492px;
        }
        &.leftposition7{
            left:492px;
        }
        &.leftposition8{
            left:510px;
        }
        &.leftposition9{
            left:510px;
        }
    }

    &:first-child{
        margin:25px auto 0;
    }

    &.newyear_box1_padding{
        &:first-child{
            margin:12px auto 0;
        }

    }

    &.newyear_box2_padding{
        &:first-child{
            margin:35px auto 0;
        }

    }



}

.newyear_box2{
    width: 936px;
    height: 98px;
    background: #FFFFFF;
    border-radius: 16px;
    margin:0 auto 22px;
    
    padding:0 32px;
    box-sizing: border-box;
    padding-top:8px;
    .width872{
        width: 872px;
        font-size: 23px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #F97723;
        line-height: 35px;
        text-align: justify;
        margin:0 auto;

    }
}























.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain{
    font-size: 0;
}

.mumcontain{
    width: 1000px;
    margin:0 auto;
    display: block;
    text-align: center;
    /*padding-top: 865px;*/
    
}
.muntitle{
    font-size:32px;
    font-family:Songti SC;
    font-weight:900;
    color:rgba(255,255,255,1);
    line-height:43px;
    text-shadow:0px 3px 8px rgba(61,186,173,0.9);
    padding:0 20px;
    vertical-align: middle;
}

.verticalalign-middle{
    vertical-align: middle;
}

.munbox{
    width:100%;
    
    
    background: #FFD1AB;
    border-radius:24px;
    padding:0 32px 29px;
    margin-top: 50px;
    box-sizing: border-box;

}

.munbox .munbox1{
    margin-top: 40px;
}
.producttype{
    display:inline-block;
    width:177px;
    height:46px;
    font-family: 'Source Han Serif CN';
    /*padding-top: 7px;*/
    box-sizing: border-box;
    line-height: 46px;
    color:#fff;
    font-size:30px;
    text-align:center;
    border-bottom-left-radius:36px;
    border-bottom-right-radius:36px;
    /*background: linear-gradient(0deg, #A9A0FF, #8360DB);*/
    background: -webkit-linear-gradient(top, #FFA266, #FB7E2E);
    background: -o-linear-gradient(top, #FFA266, #FB7E2E);
    background: -moz-linear-gradient(top, #FFA266, #FB7E2E);
    background: -ms-linear-gradient(top, #FFA266, #FB7E2E);
    background: -webkit-gradient(linear, 0% 100%, from(#FFA266), to(#FB7E2E));
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#FFA266), color-stop(100%,#FB7E2E));
    /*box-shadow: 0px 0px  8px #39b0a3;*/
}

.gradient{
    background: #000000;
    background: -moz-linear-gradient(top,  #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#000000), color-stop(100%,#ffffff));
    background: -webkit-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -o-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -ms-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: linear-gradient(to bottom,  #000000 0%,#ffffff 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#ffffff',GradientType=0 );
}
.dec{
    padding:10px 32px 18px;
    box-sizing:border-box;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #6E65C5;
    line-height: 36px;
}

.dec-text{
    /*font-size:18px;
    color:#494947;*/
    /*line-height:30px;*/
    /*text-indent:3px;*/
    text-align:left;
    /*padding:20px 32px;*/
    background-color:#fff;
    border-radius:16px;

    position:relative;
    margin-bottom: 30px;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: 500;
   color: #F97723;
    line-height: 36px;
    padding:10px 32px 18px;
    box-sizing:border-box;
    margin-top: 30px;
    
}
.tips{
    /*width: 174px;*/
    height:36px;
    line-height:36px;
    background-color:#45ccbe;
    box-sizing:border-box;
    position:absolute;
    bottom:-12px;
    right:0;
    border-bottom-right-radius:20px;
    border-top-left-radius:20px;
    text-align: center;
    background: linear-gradient(180deg, #A79EFE, #867EDD);
    padding:0 20px;
    box-sizing: border-box;
    
}
.tipstext{
    display:inline-block;
    font-size:22px;
    font-family: Source Han Sans CN;
    font-weight:400;
    color:#fff;
    line-height: 36px;
}

.productdetailcontain{
    width: 454px;
    margin-right: 22px;
    display: inline-block;
    background-color: #fff;
    border-radius:24px;
    height: 154px;
    vertical-align: top;
    cursor: pointer;

}
.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
}

.productdetailcontain:nth-of-type(2n){
    margin-right: 0px;
}

.imgcontain{
    width: 154px;
    height: 100%;
    display: inline-block;
    text-align:center;
    position: relative;
}
.center{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
}
.greenfish{
    position:absolute;
    left:4px;
    bottom:8px;
}
.class1{
    width:144px;
    height:144px;
}
.class2{
    width:45px;
    height:129px;
}
.class3{
    width:87px;
    height:111px;
}
.class4{
    width:108px;
    height:94px;
}
.class5{
    width:77px;
    height:118px;
}
.class6{
    width:109px;
    height:90px;
}
.class7{
    width:129px;
    height:128px;
}
.class8{
    width:126px;
    height:126px;
}
.class9{
    width:128px;
    height:101px;
}
.class10{
    width:143px;
    height:78px;
}

.class11{
    width:116px;
    height:98px;
}
.class12{
    width:134px;
    height:126px;
}
.class13{
    width:125px;
    height:124px;
}
.class14{
    width:98px;
    height:123px;
}
.class15{
    width:96px;
    height:99px;
}
.class16{
    width:122px;
    height:114px;
}

.class17{
    width:129px;
    height:105px;
}
.class18{
    width:123px;
    height:89px;
}
.class19{
    width:46px;
    height:120px;
}
.class20{
    width:54px;
    height:122px;
}

.flex-one{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}
.brandcover{
    padding:0px 0 0px;
}

.band{
    
    font-size:24px;
    line-height: 26px;
    font-family:PingFang SC;
    font-weight:500;
    color: #6E65C5;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
   
    color: #F97723;
    line-height: 31px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #F97723;
    line-height: 30px;
}

.title{
    font-size:18px;
    line-height: 18px;
    font-family:PingFang SC;
    font-weight:400;
    color: #6E65C5;
    padding-bottom: 18px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #F97723;
    line-height: 31px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #F97723;
    line-height: 30px;
}

.detail-tips{
    padding:5px 12px 5px 14px;
    /*height:30px;*/
    background: rgb(255 26 23 / 70%);
    border-radius:12px 0px 12px 0px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:400;
    
    color: #FEFEFE;
    line-height:16px;
    display:inline-block;
    text-align: center;
/*    opacity: 0.7;*/
   /* position: absolute;
    right: 25px;
    bottom:32px;*/
    vertical-align: bottom;

}
.address{
    /*padding-top: 16px;*/
    font-size:16px;
    line-height: 16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(121,121,121,1);
    font-size: 17px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    
    color: #F97723;
    line-height: 18px;
    vertical-align: bottom;
}

.techcontain{
    padding-top: 40px;
    box-sizing: border-box;
    width: 1042px;
    margin:0 auto;
    display: block;
    text-align: center;
}
.double11P3_desctitle{
    font-size: 36px;
    font-family: Source Han Serif CN;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    padding-bottom: 22px;
    box-sizing: border-box;

}

.double11P3_desc1{
    width: 856px;
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 46px;
    margin:0 auto;
}

.position_center{
    position: absolute;
    top:50%;
    transform: translate(0,-50%);
    width: 100%;
}

.justify-content_flex-justify{
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}
.align-items_flex-end{
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            productdata:[
            {
                tap:'护肤优品',
                // dec:'剁手必囤好物',
                destext:'干燥的冬天，对于皮肤来说也是一种考验。挑选合适的护肤品，让皮肤也“滋润”过冬。',
                // destext1:'',
                list:[
                    {
                        titleimg:'https://p1.fishqc.net/FoGqihho0qt7VIzKVyjDbRQTf-R1',
                        desc:'浓缩多种功效和成分的精华液，是每张梳妆台上不可缺少的护肤品之一。选购时不仅要看功效，安全性也是不能忽视的一环。',
                        leftposition:'leftposition1',
                        product:[
                            {
                                img:'https://p1.fishqc.net/FpvoXc4Tb192LypppUf353e2AsZn',
                                class:'class1',
                                brand:'PURID朴理',
                                title:'创研修护焕漾精华液（2号精华）',
                                tips:'抗红御氧',
                                address:'中国',
                                type:'cosmetic',
                                id:'uBKKOZ0Ao5UKRKyj9CEC6g',
                                position:'left',
                                width:"width1",
                                title_width:'title_width1',
                                munbox1:'munbox1'

                            },{
                                img:'https://p1.fishqc.net/Ft4VhIL8BLJPjwZNzoQHCRS5TMAq',
                                class:'class2',
                                brand:'SHISEIDO资生堂',
                                title:'红妍肌活精华露',
                                tips:'细腻补水',
                                address:'日本',
                                type:'cosmetic',
                                id:'mle-7Lk6Zoc9nmF_WpNDVQ',
                                position:'left',
                                width:"width2",
                                title_width:'title_width2'

                            }
                        ]
                    },
                    {
                        titleimg:'https://p1.fishqc.net/FqfcpzfgoXDU0L8-J_8usjPrt5Hd',
                        desc:'寒冬来袭，面霜可以帮我们锁住护肤品的养分，还能起到保湿的作用。所以，冬天选购一瓶带有安全绿鱼的面霜尤为重要。',
                        leftposition:'leftposition2',
                        product:[
                            {
                                img:'https://p1.fishqc.net/FvCskT-sc8gENxmeCukXXd7Dt82v',
                                class:'class3',
                                brand:'MyClorisLand花皙蔻 ',
                                title:'菁纯牡丹抗皱淡纹精华霜',
                                tips:'紧致淡纹',
                                address:'中国',
                                type:'cosmetic',
                                id:'li4ioIgu8L4wYXMSzN4LYA',
                                position:'left',
                                width:"width1",
                                title_width:'title_width1',
                                munbox1:'munbox1'

                            },{
                                img:'https://p1.fishqc.net/FpVziKJruLPbcN3cgl50LV4SYj_6',
                                class:'class4',
                                brand:'CUREL珂润 ',
                                title:'淡纹紧致滋养乳霜',
                                tips:'温和舒缓',
                                address:'日本',
                                type:'cosmetic',
                                id:'2so1aRbi2EfosWCY8a0aPw',
                                position:'left',
                                width:"width2",
                                title_width:'title_width2'

                            }
                        ]
                    },
                    {
                        titleimg:'https://p1.fishqc.net/FkVAShPI2bZRLuDU_H6xOgD2fRWh',
                        desc:'就算是天气冷，也不能忽略面膜的重要性。越是寒冷干燥，就越需要面膜保湿，助我们度过干燥冬季。得到安全绿鱼的面膜，用的就更放心啦。',
                        leftposition:'leftposition3',
                        product:[
                            {
                                img:'https://p1.fishqc.net/Fmcup9QZGsFzmVn7Gn9er5TcDW22',
                                class:'class5',
                                brand:'SK-II 护肤面膜 ',
                                title:'前男友面膜',
                                tips:'经典王炸',
                                address:'日本',
                                type:'cosmetic',
                                id:'kYKQut3tj8dGzCXOT99lSQ',
                                position:'left',
                                width:"width1",
                                title_width:'title_width1',
                                munbox1:'munbox1'

                            },{
                                img:'https://p1.fishqc.net/FpFuhZGlYvWi9so8qxb6enZyo5V8',
                                class:'class6',
                                brand:'雪肌精 ',
                                title:'馨白按摩面膜',
                                tips:'滋润提亮',
                                address:'日本',
                                type:'cosmetic',
                                id:'u5WqMS36PXhnSs2xfhqctQ',
                                position:'left',
                                width:"width2",
                                title_width:'title_width2'

                            }
                        ]
                    }
                ]
                
                
            },
            {
                tap:'母婴优品',
                // dec:'剁手必囤好物',
                destext:'宝宝和妈妈都需要特别的呵护，挑选安全又好用的母婴产品可以给予宝宝和妈妈<br>更多的安全感。',
                // destext1:'',
                list:[
                    {
                        titleimg:'https://p1.fishqc.net/FlFL0H95qnvBNHwVnbWoEhWR1vNm',
                        desc:'为了让妈妈们尽量不留下妊娠纹，妊娠油是孕期必不可少的产品之一。得到绿鱼认证的妊娠油，让妈妈们可以放心地预防和淡化妊娠纹。',
                        leftposition:'leftposition4',
                        product:[
                            {
                                img:'https://p1.fishqc.net/Fpw14ZuRBW2TmML79TZliaM-OyjF',
                                class:'class7',
                                brand:'Kangaroo mommy袋鼠妈妈 ',
                                title:'舒纹橄榄精华油',
                                tips:'预防淡化',
                                address:'中国',
                                type:'cosmetic',
                                id:'UJQtRGSGnp5DqiOPhREIew',
                                position:'left',
                                width:"width1",
                                title_width:'title_width1',
                                munbox1:'munbox1'

                            },{
                                img:'https://p1.fishqc.net/Fp8yOU_1mR5ZurVLMguuczknGaIj',
                                class:'class8',
                                brand:'BIO-OIL百洛 ',
                                title:'护肤油',
                                tips:'弹润抚纹',
                                address:'美国',
                                type:'cosmetic',
                                id:'dHFf1P9DuciXKbToFwcnvg',
                                position:'left',
                                width:"width2",
                                title_width:'title_width2'

                            }
                        ]
                    },
                    {
                        titleimg:'https://p1.fishqc.net/FmAbXaLl87wndxtAsB0EXTTblO2d',
                        desc:'小朋友的皮肤相对来说更加敏感、脆弱，使用专门的儿童湿巾很有必要。经过小鱼亲测绿鱼认证的儿童湿巾，可以让宝宝和妈妈用的更加安心。',
                        leftposition:'leftposition5',
                        product:[
                            {
                                img:'https://p1.fishqc.net/FnPWt4Cl-tfuKengrjCgdJUyNsvv',
                                class:'class9',
                                brand:'NUK  ',
                                title:'超厚特柔婴儿湿巾',
                                tips:'超厚特柔',
                                address:'德国',
                                type:'cosmetic',
                                id:'D-gqI-3K4G1ZDGXoEF-TeQ',
                                position:'left',
                                width:"width1",
                                title_width:'title_width1',
                                munbox1:'munbox1'

                            },{
                                img:'https://p1.fishqc.net/FpsWqEUi4ugoEXaNxCMHjo-OBeRp',
                                class:'class10',
                                brand:'PIGEON贝亲  ',
                                title:'婴儿水润洁肤巾',
                                tips:'清爽滋润',
                                address:'日本',
                                type:'cosmetic',
                                id:'j0uoA0G32vu6eHV1tgJWfA',
                                position:'left',
                                width:"width2",
                                title_width:'title_width2'

                            }
                        ]
                    },
                    {
                        titleimg:'https://p1.fishqc.net/Fj85zPbWCH9FysqTrGZV504OOeTu',
                        desc:'纸尿裤接触着宝宝最娇嫩的肌肤，所以寻找一款舒适、不易引起敏感的纸尿裤对于宝妈们来说也是件“头等大事”。带有绿鱼标识是纸尿裤，宝妈们也可以安心选购。',
                        leftposition:'leftposition6',
                        product:[
                            {
                                img:'https://p1.fishqc.net/FpDLxXbeQFeWBHavzgyfi2ddJVe6',
                                class:'class11',
                                brand:'PAMPERS帮宝适 ',
                                title:'超薄干爽婴儿纸尿裤 小号',
                                tips:'轻薄干爽',
                                address:'美国',
                                type:'cosmetic',
                                id:'k_qs-gmJONTrgqg2cNdHRw',
                                position:'left',
                                width:"width1",
                                title_width:'title_width1',
                                munbox1:'munbox1'

                            },{
                                img:'https://p1.fishqc.net/Fi565b0qa1xyE1iizc1mejFc2Lvj',
                                class:'class12',
                                brand:'MERRIES妙而舒  ',
                                title:'婴儿纸尿裤中号',
                                tips:'透气绵柔',
                                address:'日本',
                                type:'cosmetic',
                                id:'ouXM1WevCGFdmhYqYoQabA',
                                position:'left',
                                width:"width2",
                                title_width:'title_width2'

                            }
                        ]
                    }
                ]
                
                
            },
            {
                tap:'美妆优品',
                // dec:'剁手必囤好物',
                destext:'新年快到了，备上几款安全好用的化妆品，美美的过新年。',
                // destext1:'',
                list:[
                    {
                        titleimg:'https://p1.fishqc.net/FqIS5hZpz2fQ_cIiP4nyp8By4aP7',
                        desc:'作为妆面的基础，粉底液这个“地基”打好对后续的上妆和持妆都很重要。选购一款好用又安全的粉底液，就是好上加好。',
                        leftposition:'leftposition7',
                        product:[
                            {
                                img:'https://p1.fishqc.net/FuVG3oNs0JJxdoTfxfZW1oxDnCjb',
                                class:'class13',
                                brand:'DIOR迪奥  ',
                                title:'Forever 锁妆粉底液 哑光妆效 1N',
                                tips:'锁妆服帖',
                                address:'法国',
                                type:'cosmetic',
                                id:'wYJZj1oFh_oktdJKa_FXWA',
                                position:'left',
                                width:"width1",
                                title_width:'title_width1',
                                munbox1:'munbox1'

                            },{
                                img:'https://p1.fishqc.net/FqUhGKB2itKcnflNKbsGdEIPLqNV',
                                class:'class14',
                                brand:'GUERLAIN娇兰  ',
                                title:'丝柔亲肤粉底液(02N Clair Light)',
                                tips:'清透无瑕',
                                address:'法国',
                                type:'cosmetic',
                                id:'IR1SNoQen5rjK053MqWUYQ',
                                position:'left',
                                width:"width2",
                                title_width:'title_width2'

                            }
                        ]
                    },
                    {
                        titleimg:'https://p1.fishqc.net/FkQvsmxnwfDTkUw3hi6X4ERgL5bg',
                        desc:'眼睛是心灵的窗户，眼妆对于整体妆容可以起到画龙点睛的作用。带有绿鱼标识的眼影，不仅能提升妆容的质感，还能带来满满的安全感。',
                        leftposition:'leftposition8',
                        product:[
                            {
                                img:'https://p1.fishqc.net/FnBxd02ApHfoC2ffijokHjtRW2gW',
                                class:'class15',
                                brand:'MAC魅可 ',
                                title:'时尚焦点小眼影-闪耀星辰系列<br> (LAST DANCE)  ',
                                tips:'人气热卖',
                                address:'加拿大',
                                type:'cosmetic',
                                id:'d-MfZkDkz1FmpaZUEDZZ1Q',
                                position:'left',
                                width:"width1",
                                title_width:'title_width1',
                                munbox1:'munbox1'

                            },{
                                img:'https://p1.fishqc.net/Fn0jU6E4_LwzWQ7lXRBmW1vSPa1u',
                                class:'class16',
                                brand:'CANMAKE井田  ',
                                title:'魅色星璨眼影 (14 古典深红) ',
                                tips:'复古自然',
                                address:'日本',
                                type:'cosmetic',
                                id:'ltFePk1nUYcInGsmUMN5Fg',
                                position:'left',
                                width:"width2",
                                title_width:'title_width2'

                            }
                        ]
                    },
                    {
                        titleimg:'https://p1.fishqc.net/FuKUVxtbpqnGPsl_eQEd-_nwILQH',
                        desc:'合适的腮红可以提升人的气质和气色。认准经过小鱼亲测绿鱼认证的腮红产品，能让你安全又美丽。',
                        leftposition:'leftposition9',
                        product:[
                            {
                                img:'https://p1.fishqc.net/FhMO7TtYL1qlfWlmUTxCMKxWMAFI',
                                class:'class17',
                                brand:'MAQUILLAGE心机彩妆  ',
                                title:'星魅腮红',
                                tips:'元气透亮',
                                address:'日本',
                                type:'cosmetic',
                                id:'MFd41MJhOh9O2s7alN4uJA',
                                position:'left',
                                width:"width1",
                                title_width:'title_width1',
                                munbox1:'munbox1'

                            },{
                                img:'https://p1.fishqc.net/FsGFxWPiChJy6r01fNo-Yuaw-bDi',
                                class:'class18',
                                brand:'MUJI无印良品   ',
                                title:'腮红哑光型桃红色 (A47)',
                                tips:'自然显色',
                                address:'日本',
                                type:'cosmetic',
                                id:'t-X4FME8gczg8TXpD-CXCQ',
                                position:'left',
                                width:"width2",
                                title_width:'title_width2'

                            }
                        ]
                    }
                ]
                
                
            },
        ],
        
      
        imgarr:['https://product.fishqc.com/img/activity/618/tech.png','https://product.fishqc.com/img/activity/618/tech-white.png','https://product.fishqc.com/img/activity/618/tech-kangyang.png'],
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            this.$router.push({
                path: '/product/'+type+'/'+prdid
            })
            
        }
    }
}
</script>